import { BadgeIcon } from '@/components/TokenProfile/TokenProfileSecurityAudit/RiskIcons/BadgeIcon';

import {
  SECURITY_LEVEL_TO_BADGE_VARIANT,
  useSecurityAssessment,
} from '@/hooks/useSecurityAssessment';

import { fontStyles } from '@/styles/typography';

import type { TokenResult } from '@/utils/0x/token-registry.types';

export const SecurityScore = ({ token }: { token: TokenResult | undefined }) => {
  const { level, risks: riskCount } = useSecurityAssessment({
    activeToken: token,
  });

  const issues = `${riskCount} ${riskCount === 1 ? 'Risk' : 'Risks'}`;
  const securityLabel = level === 'Danger' ? 'Danger' : level === 'Pending' ? 'Pending' : issues;
  const badgeVariant = SECURITY_LEVEL_TO_BADGE_VARIANT[level];

  return (
    <div
      className={fontStyles({
        variant: 'LABEL_SM',
        class: [
          'items-center',
          'rounded-xl',
          'flex',
          'justify-center',
          'h-8',
          'px-3',
          'gap-1.5',
          'outline-none',
          'pointer-events-none',
          'bg-token-alphalight-300',
          'hover:bg-token-alphalight-400',
          'active:bg-token-alphalight-400',
          'focus-visible:outline-token-alphalight-500',
          'focus-visible:outline-2',
          'focus-visible:outline-solid',
        ],
      })}
    >
      <div className="flex-shrink-0">
        <BadgeIcon variant={badgeVariant} />
      </div>
      <span
        className={fontStyles({
          variant: 'LABEL_SM',
          class: ['ml-1', 'whitespace-nowrap', 'text-token-gray-1600'],
        })}
      >
        {securityLabel}
      </span>
    </div>
  );
};
